var map = {
	"./black/full.png": "gz4F",
	"./blue/full.png": "4HMN",
	"./white/full.png": "5nxN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6gy7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/full\.png$
// module id = 6gy7
// module chunks = 24